import { useContext } from 'react'

import { AuthContext } from '@/contexts/AuthContext'

import '@paysense-india-services/auth-vista/dist/login.css'

export default function LoginLayout({ children }) {
  const { isUserLoggedIn } = useContext(AuthContext)
  return !isUserLoggedIn ? (
    <div className='ew-bg-secondary ew-h-100 ew-d-flex ew-flex-column'>{children}</div>
  ) : null
}
